import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlHandlingStrategy, PreloadAllModules } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { AuthGuardService } from './_auth/auth-guard.service';

// import { ErrorPageComponent } from './_pages/error-page.component';

export class CustomHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url) {
    return url.toString().startsWith('/ng') || url.toString() === '/';
  }
  extract(url) {
    return url;
  }
  merge(url, whole) {
    return url;
  }
}

const routes: Routes = [
  {
    path: 'ng/integrations',
    loadChildren: () =>
      import('./company-integrations/company-integrations.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },
  {
    path: 'ng/chart_accounts',
    loadChildren: () => import('./chart-accounts/chart-accounts.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },
  {
    path: 'ng/players',
    loadChildren: () => import('./players/players.module').then((m) => m.PlayersModule),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/home',
    loadComponent: () =>
      import('./_pages/home/home-page.component').then((m) => m.HomePageComponent),
    data: { title: 'DASHBOARD' },
    canActivate: [AuthGuardService],
  },

  // Account settings
  {
    path: 'ng/account_settings',
    loadComponent: () =>
      import('./_pages/account-settings/account-settings-page.component').then(
        (m) => m.AccountSettingsPageComponent
      ),
    data: { title: 'ACCOUNT_SETTINGS', menu: 'settings' },
    canActivate: [AuthGuardService],
  },

  {
    path: 'ng/company_settings',
    loadComponent: () =>
      import('./_pages/company-settings/company-settings-page.component').then(
        (m) => m.CompanySettingsPageComponent
      ),
    data: { title: 'COMPANY_SETTINGS', menu: 'settings' },
    canActivate: [AuthGuardService],
  },

  {
    path: 'ng/companies',
    loadChildren: () => import('./companies/companies.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/websites',
    loadChildren: () => import('./websites/websites.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/users',
    loadChildren: () => import('./users/users.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/roles',
    loadChildren: () => import('./roles/roles.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/seasons',
    loadChildren: () => import('./seasons/seasons.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/pax_ranges',
    loadChildren: () => import('./pax-ranges/pax-ranges.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/languages',
    loadChildren: () => import('./languages/languages.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/categories',
    loadChildren: () => import('./categories/categories.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/facilities',
    loadChildren: () => import('./facilities/facilities.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/what_to_bring',
    loadChildren: () => import('./what-to-bring/what-to-bring.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/occupancy_types',
    loadChildren: () => import('./occupancy-types/occupancy-types.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/room_types',
    loadChildren: () => import('./room-types/room-types.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/countries',
    loadChildren: () => import('./countries/countries.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/locations',
    loadChildren: () => import('./locations/locations.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/zones',
    loadChildren: () => import('./zones/zones.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/pickup_places',
    loadChildren: () => import('./pickup-places/pickup-places.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  // Account settings
  {
    path: 'ng/currencies',
    loadChildren: () => import('./currencies/currencies.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/bookings_report',
    loadChildren: () => import('./bookings-report/bookings-report.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/sales_report',
    loadChildren: () => import('./sales-report/sales-report.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/cash_closing_report',
    loadChildren: () =>
      import('./cash-closing-report/cash-closing-report.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/purchases_report',
    loadChildren: () => import('./purchases-report/purchases-report.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  // Anon
  {
    path: 'ng/login',
    loadComponent: () =>
      import('./_pages/login/login-page.component').then((m) => m.LoginPageComponent),
    data: { title: 'LOGIN' },
  },
  {
    path: 'ng/password_recovery',
    loadComponent: () =>
      import('./_pages/password-recovery/password-recovery-page.component').then(
        (m) => m.PasswordRecoveryPageComponent
      ),
    data: { title: 'FORGOT_PASSWORD' },
  },
  // { // Use when all app is refactored to Angular +
  //   // path: 'ng/password_recovery/:token/edit',
  //   path: 'ng/password_recovery/edit',
  //   loadComponent: () =>
  //     import('./_pages/password-recovery-edit/password-recovery-edit-page.component').then(
  //       (m) => m.PasswordRecoveryEditPageComponent
  //     ),
  //   data: { title: 'RESET_YOUR_PASSWORD' },
  // },
  {
    path: 'ng/account_activation',
    loadComponent: () =>
      import('./_pages/account-activation-page.component').then(
        (m) => m.AccountActivationPageComponent
      ),
    // canActivate: [AuthGuardService],
  },

  // Register page ?

  {
    path: 'ng/opportunities',
    loadChildren: () => import('./opportunities/opportunities.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: 'ng/leads',
    loadChildren: () => import('./leads/leads.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },
  {
    path: 'ng/clients',
    loadChildren: () => import('./clients/clients.routes').then((m) => m.routes),
    canLoad: [AuthGuardService],
  },

  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'ng/home',
  },

  // { path: '**', component: ErrorPageComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules, // This preload all Modules/Components in the brackground
      // useHash: true, // if true we have issues with ng-view & router-outlet - remove strategy when fully migrated
      // enableTracing: true,
    }),
    TranslateModule.forChild(),
  ],
  exports: [RouterModule, TranslateModule],
  providers: [{ provide: UrlHandlingStrategy, useClass: CustomHandlingStrategy }],
})
export class AppRoutingModule {}

// Normal loading int the main.js
// import { AccountSettingsPageComponent } from './_pages/account-settings/account-settings-page.component';
// {
//   path: 'ng/account_settings',
//   component: AccountSettingsPageComponent,
//   data: { title: 'ACCOUNT_SETTINGS' },
//   canActivate: [AuthGuardService],
// },
